export class CreateCloudEnvironmentResponse {
    environmentId?: string;
}